import { FormElems } from 'components';
import { MLE_ONBOARDING } from 'containers/Checker/checker.constants';
import React from 'react';
import { APPROVE, REJECT, SUBMIT_CHECKER } from './constant';

const SubmitButton = (props) => {
    const {
        isViewMode, 
        requestDetails,
        setIsApproved,
        setButtonAction,
        approveDisable,
        raisedToLevel,
        loggedInUserLevel,
        parentEventType
    } = props;
    return (
        <>
            {!isViewMode && parentEventType === MLE_ONBOARDING && (
                <div className="form-section">
                    <FormElems.Button
                        buttonType="secondary"
                        text="REJECT"
                        id="back-btn"
                        handleClick={() => {
                            setIsApproved(false);
                            setButtonAction(REJECT);
                        }}
                        customClass="back-btn"
                        isDisable={!approveDisable}
                    />
                    {raisedToLevel !== 'null' && raisedToLevel && (
                        <FormElems.Button
                            id="raise-btn"
                            buttonType="secondary"
                            text="RAISE TO LEVEL"
                            handleClick={() => {
                                setIsApproved(true);
                                setButtonAction('RAISE_TO_LEVEL');
                            }}
                            customClass="back-btn"
                            isDisable={loggedInUserLevel === 'L3'}
                        />
                    )}
                    <FormElems.Button
                        id="next-btn"
                        buttonType="primary"
                        text="APPROVE"
                        handleClick={() => {
                            setIsApproved(true);
                            setButtonAction(APPROVE);
                        }}
                        isDisable={approveDisable}
                    />
                </div>
            )}

            {!isViewMode && parentEventType !== MLE_ONBOARDING && (
                <div className="form-section">
                
                    {raisedToLevel !== 'null' && raisedToLevel && (
                        <FormElems.Button
                            id="raise-btn"
                            buttonType="secondary"
                            text="RAISE TO LEVEL"
                            handleClick={() => {
                                setIsApproved(true);
                                setButtonAction('RAISE_TO_LEVEL');
                            }}
                            customClass="back-btn"
                            isDisable={loggedInUserLevel === 'L3'}
                        />
                    )}
                    <FormElems.Button
                        id="next-btn"
                        buttonType="primary"
                        text="SUBMIT"
                        handleClick={() => {
                            setButtonAction(SUBMIT_CHECKER);
                        }}
                    />
                </div>
            )}
        </>
    );
};

export default SubmitButton;
